// Thin client-side analytics wrapper.
//
// posthog-js is initialized by the shared application/login packs. This wrapper
// keeps callers isolated from analytics failures and from pages where PostHog is
// intentionally disabled because no project token was exposed.
//
// Use trackEvent() liberally. It is safe to call on every interesting user
// action; failures are swallowed so analytics never break a page.
//
// Default events the v2 workout builder emits (others can be added freely —
// the four below are the launch-critical ones called out in the spec):

export const EVENTS = Object.freeze({
  OPENED:          'wbv2_opened',
  SAVED:           'wbv2_saved',
  EXERCISE_ADDED:  'wbv2_exercise_added',
  LINK_TOGGLED:    'wbv2_link_toggled',
  FORM_EDIT_SCOPE_CHOSEN: 'form_edit_scope_chosen',
  FORM_BUILDER_SECTION_ADDED: 'form_builder_section_added',
  REPEAT_OCCURRENCE_REMOVED: 'repeat_occurrence_removed',
  REPEAT_SAVE_SCOPE_CHOSEN: 'repeat_save_scope_chosen',
  REPEAT_REMOVE_UNDONE: 'repeat_remove_undone',
  // Coach first-run product tour (CC-1034).
  ONBOARDING_TOUR_STARTED:     'onboarding_tour_started',
  ONBOARDING_TOUR_STEP_VIEWED: 'onboarding_tour_step_viewed',
  ONBOARDING_TOUR_SKIPPED:     'onboarding_tour_skipped',
  ONBOARDING_TOUR_COMPLETED:   'onboarding_tour_completed',
  ONBOARDING_TOUR_REPLAYED:    'onboarding_tour_replayed',
  // Cancel flow rebuild (CC-1072). Backend fires 'Canceled Subscription'.
  CANCEL_PAGE_VIEWED:          'Cancel Page Viewed',
  CANCEL_VIDEO_PLAYED:         'Cancel Video Played',
  CANCEL_VIDEO_COMPLETED:      'Cancel Video Completed',
  CANCEL_TRANSCRIPT_OPENED:    'Cancel Transcript Opened',
  CANCEL_REASON_SELECTED:      'Cancel Reason Selected',
  CANCEL_SAVE_OFFER_CLICKED:   'Cancel Save Offer Clicked',
  CANCEL_SUPPORT_CHAT_OPENED:  'Cancel Support Chat Opened',
  CANCEL_CONFIRM_VIEWED:       'Cancel Confirm Viewed',
  CANCEL_REACTIVATE_CLICKED:   'Reactivate Clicked',
  CLOSED_ACCOUNT_SCREEN_VIEWED: 'Closed Account Screen Viewed',
  // Landing-page speed work (speed-improvement branch): before/after visibility
  // for API request count and load time on key pages.
  PAGE_LOAD_METRICS: 'page_load_metrics',
});

export function trackEvent(event, props = {}) {
  if (!event) return;
  try {
    if (typeof window === 'undefined') return;
    const ph = window.posthog;
    if (ph && typeof ph.capture === 'function') {
      ph.capture(event, props);
      return;
    }
    // Optional debug trail — visible only when the localStorage flag is set.
    if (typeof localStorage !== 'undefined' && localStorage.getItem('cc_analytics_debug') === '1') {
      // eslint-disable-next-line no-console
      console.debug('[analytics:noop]', event, props);
    }
  } catch (_) {
    // Never let telemetry crash the page.
  }
}

// Convenience for tests + future consumers who want a sane default object.
export default { EVENTS, trackEvent };
